import React, { Component } from 'react';
import { connect } from 'react-redux';

import CreateBoard from './CreateBoard';
import { boards } from '../actions';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

class NoBoards extends Component {
  constructor() {
    super();
    this.state = {
      show: true,
      title: '',
    };
  }
  showModal = () => {
    this.setState({ show: true });
  };
  hideModal = () => {
    this.setState({ show: false });
  };

  handleTitle = e => {
    e.preventDefault();
    this.setState({ title: e.target.value });
  }

  onSubmit = e => {
    e.preventDefault();
    if (this.state.title) {
      this.props.createBoard(this.state.title);
      window.analytics.track("Board Created", {
        board: this.state.title,
      });
    }
    history.push('/browse');
    window.location.reload();
  }

  render() {
    return(
      <div className="grid">
        <div className="info">
          <img className="icon-ui" src="https://s3-us-west-2.amazonaws.com/pinstripelabs.com/icon-graphic-setup.png" alt="Pinstripe graphic setup" />
          <h3>Set up your first project and pick your apps</h3>
          <br/>
          <button className="btn" onClick={this.showModal}>Create my 1st stack</button>
          <br/><br/>
          {/*<p>Need help? <a className="underline" href="https://surveys.hotjar.com/s?siteId=1061910&surveyId=126808" target="_blank" rel="nofollow noreferrer">Schedule a walkthrough</a> or follow our <a className="underline" href="https://medium.com/pinstripe/getting-started-with-pinstripe-3d5f6d9ebb7" target="_blank" rel="noopener noreferrer">quick start guide</a> to learn at your own pace.</p>
    */}
          </div>
        <CreateBoard show={this.state.show} handleClose={this.hideModal} onSubmit={this.onSubmit} handleInput={this.handleTitle} resetInput={this.resetForm} />        
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    boards: state.boards,
  }
}

const mapStateToDispatch = dispatch => {
  return {
    createBoard: (title) => {
      return dispatch(boards.createBoard(title));
    },
  }
}

export default connect(mapStateToProps, mapStateToDispatch)(NoBoards);


// WEBPACK FOOTER //
// ./src/components/NoBoards.js